export default {
  name: 'publish',
  BASE_URL: 'https://ksh-api.yaomaitong.cn',
  CND_URL: 'https://ksh-api.yaomaitong.cn'
};
